var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"col-lg-12 text-center mb-3"},[_vm._v(_vm._s(_vm.$t('editCategory')))]),_c('FormCategory',{attrs:{"baseCategory":_vm.category},on:{"submit-requested":_vm.submitRequested}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }